<template lang='pug'>
  div(class="c-radio__wrapper")
    //-- a(href='http://198.178.121.76:8084/index.html?sid=1', target='_blank')
    button(id="radio_btn" class="c-radio__btn", :class = "classAnimation ? 'animation' : ''" @click="toggleMuted")
        i(class="u-icon") radio
    audio(id="radio_audio" src="https://cp13.shoutcheap.com:18084/;")
</template>

<script>
  export default {
    data () {
      return {
        classAnimation: false,
        showControl: false
      }
    },

    methods: {
      toggleMuted () {
        let audio = document.getElementById('radio_audio')
        this.classAnimation = !this.classAnimation
        audio.play()
        audio.muted = !audio.muted
      },
      initPlay () {
        let audio = document.getElementById('radio_audio')
        audio.muted = !audio.muted
        audio.oncanplay = () => {
          audio.play()
          this.showControl = true
        }
        audio.onplaying = () => {
          audio.muted = false
          this.classAnimation = true
        }
      }
    },

    mounted () {
      this.initPlay()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/AppRadio.vue